import React, { Component } from "react";
import {
  Button,
  ButtonGroup,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter
} from "reactstrap";
import DayPicker from "react-day-picker";

class ProjAssignmentDatesModal extends Component {
  render() {
    const {
      showProjAssignmentDatesModal,
      toggleProjAssignmentDatesModal,
      startDateSelected,
      toggleDateType,
      handleDayClick,
      assignedStaff
    } = this.props;
    return (
      <Modal
        isOpen={showProjAssignmentDatesModal}
        toggle={toggleProjAssignmentDatesModal}
        size={"sm"}
        fade={false}
      >
        <ModalHeader toggle={toggleProjAssignmentDatesModal}>
          Assignment Dates
        </ModalHeader>
        <ModalBody>
          <div className="card">
            <div className="card-body p-3">
              <div className="row ml-2">
                <ButtonGroup>
                  <Button
                    name="startDate"
                    id="startDate"
                    color="secondary"
                    outline
                    onClick={toggleDateType}
                    active={startDateSelected}
                  >
                    Start Date
                  </Button>
                  <Button
                    name="endDate"
                    id="endDate"
                    color="secondary"
                    outline
                    onClick={toggleDateType}
                    active={!startDateSelected}
                  >
                    End Date
                  </Button>
                </ButtonGroup>
              </div>
              <div className="row">
                <DayPicker
                  onDayClick={handleDayClick}
                  month={
                    assignedStaff &&
                    (startDateSelected
                      ? assignedStaff.startDate &&
                        new Date(assignedStaff.startDate)
                      : assignedStaff.endDate &&
                        new Date(assignedStaff.endDate))
                  }
                  selectedDays={
                    assignedStaff &&
                    (startDateSelected
                      ? assignedStaff.startDate &&
                        new Date(assignedStaff.startDate)
                      : assignedStaff.endDate &&
                        new Date(assignedStaff.endDate))
                  }
                />
              </div>
            </div>
          </div>
        </ModalBody>
        <ModalFooter>
          <Button color="primary" onClick={toggleProjAssignmentDatesModal}>
            Save
          </Button>{" "}
          <Button color="secondary" onClick={toggleProjAssignmentDatesModal}>
            Cancel
          </Button>
        </ModalFooter>
      </Modal>
    );
  }
}

export default ProjAssignmentDatesModal;
